module.exports = __webpack_public_path__ + "assets/img/2-1.62f6d015.jpg";